import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const OrderStatusChart = () => {
  const data = [
    { name: 'Completed', value: 1247, color: '#10B981' },
    { name: 'In Progress', value: 324, color: '#F59E0B' },
    { name: 'Active', value: 156, color: '#3B82F6' },
    { name: 'Disputed', value: 23, color: '#EF4444' },
    { name: 'Cancelled', value: 89, color: '#6B7280' }
  ];

  const total = data?.reduce((sum, item) => sum + item?.value, 0);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      const data = payload?.[0];
      const percentage = ((data?.value / total) * 100)?.toFixed(1);
      return (
        <div className="bg-popover border border-border rounded-lg p-3 elevation-2">
          <p className="font-medium text-foreground">{data?.name}</p>
          <p className="text-sm text-muted-foreground">
            {data?.value?.toLocaleString()} orders ({percentage}%)
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">Order Status Distribution</h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={40}
              outerRadius={80}
              paddingAngle={2}
              dataKey="value"
            >
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="space-y-3 mt-4">
        {data?.map((item, index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div 
                className="w-3 h-3 rounded-full" 
                style={{ backgroundColor: item?.color }}
              ></div>
              <span className="text-sm text-foreground">{item?.name}</span>
            </div>
            <div className="text-right">
              <p className="text-sm font-medium text-foreground">{item?.value?.toLocaleString()}</p>
              <p className="text-xs text-muted-foreground">
                {((item?.value / total) * 100)?.toFixed(1)}%
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderStatusChart;